// The tabs of Inventory (pages/Inventory.js) — the whole store on one page.
//
// It used to be four sidebar entries (Stock, Requests, Purchasing, Indents) with
// vendors and the quotation comparison buried inside Purchasing and the costing
// endpoint on no screen at all. The flow it now follows is the one the seafood
// ERPs keep their packing and consumables stores to:
//
//   Stock (low stock flags itself) → Indent → Quote / PO → Receive (GRN) → Issue
//   … and packing material leaves on its own, from the packing recipe, when
//   production confirms the cartons.
//
// This list lives apart from the page because two places need it and they must
// not drift: the page decides which tab to render, and Layout decides whether the
// single nav entry is worth showing at all (`anyOf`). `moduleKey` / `featureCode`
// are the pair each old sidebar entry carried, so a tab is gated exactly as its
// entry was (hooks/useNavVisibility).
//
// Indents has two engines: Inventory Requests where it is on, and the legacy
// indent workflow for a tenant that has not switched approvals on. `anyOf` makes
// the tab visible for either; the page picks which one to render.
//
// Only three tabs sit in the strip, split by which way material moves, because
// mixing them on one list is what confused the store:
//   Stock          — what is here, occupied, on order
//   Buy & receive  — purchase requests, POs (drafts, approvals, debit notes),
//                    receiving against a PO or without one
//   Move out       — issues to production / packing / cold store, other use,
//                    damage, stock count corrections
// Vendors, Vendor ledgers and Costing are set up or read now and then, so they live in the
// page's "More" menu (`more: true`). Old keys (`indents`, `purchase`) are mapped
// by the page, because notifications already sent carry them.
const INVENTORY_TABS = [
  { key: 'stock', label: 'Stock', hint: 'What is in the store', moduleKey: 'inventoryItems', featureCode: 'materialsInventory' },
  {
    key: 'buy', label: 'Buy & receive', hint: 'Purchase requests, POs, deliveries',
    anyOf: [
      { moduleKey: 'inventoryRequests', featureCode: 'inventoryRequests' },
      { moduleKey: 'indents', featureCode: 'indentWorkflow' },
      { moduleKey: 'purchaseOrders', featureCode: 'purchaseOrders' },
    ],
  },
  { key: 'out', label: 'Move out', hint: 'Issues, other use, damage, counts', moduleKey: 'inventoryRequests', featureCode: 'inventoryRequests' },
  { key: 'vendors', label: 'Vendors', moduleKey: 'purchaseOrders', featureCode: 'vendorManagement', more: true },
  // The store's suppliers on their own ledger accounts — never procurement parties.
  { key: 'ledgers', label: 'Vendor ledgers', moduleKey: 'purchaseOrders', featureCode: 'vendorManagement', more: true },
  // Costing is business money; the page also hides it below the full money tier.
  { key: 'costing', label: 'Costing', moduleKey: 'inventoryItems', featureCode: 'materialsInventory', money: true, more: true },
];

export default INVENTORY_TABS;
